import { Loader } from "components";
import styles from "./FullLoader.module.scss";
import { LoaderInt } from "interfaces";

const FullLoader = ({ className }: LoaderInt) => {
  return (
    <div className={`${className} ${styles.loading}`}>
      <Loader />
    </div>
  );
};

export default FullLoader;
